import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 3,
  policySubType: 0,
  holderType: 2,
};

export function getDlpOneDriveTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined,
  mipEnabled: boolean
) {
  let ntfI18nReplaceKeys = [];
  if (mipEnabled) {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfInternalRecipientSubject',
      'policy.policyTemplate.MIP_OD.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.MIP_OD.tmDpfilters.notification.ntfInternalRecipientMessage',
    ];
  } else {
    ntfI18nReplaceKeys = [
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfAdminMessage',
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfAdminSubject',
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfInternalRecipientMessage',
      'policy.policyTemplate.OD.tmDpfilters.notification.ntfInternalRecipientSubject',
    ];
  }
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
